export default __webpack_public_path__ + "static/media/hire.1952f487.png";